import { render, staticRenderFns } from "./AppifyAuth.vue?vue&type=template&id=495e5792"
import script from "./AppifyAuth.vue?vue&type=script&lang=js"
export * from "./AppifyAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports